module.exports = LoginController;

LoginController.$inject = ['Authentication','$location'];
function LoginController(Authentication, $location) {
    Authentication.openLogin();
    $location.url('/');
}



// WEBPACK FOOTER //
// ./app/common/auth/login.controller.js